const CAMPAIGN_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

export type CampaignParams = Partial<Record<(typeof CAMPAIGN_PARAMS)[number], unknown>>

// Only marketing labels cross the auth-domain boundary, never identity or access tokens.
export function appendCampaignParams(url: URL, params: CampaignParams) {
  for (const key of CAMPAIGN_PARAMS) {
    const value = params[key]
    if (typeof value === 'string' && value.length > 0 && value.length <= 200) {
      url.searchParams.set(key, value)
    }
  }
}

export function readCampaignParams(search: string, getProperty: (key: string) => unknown) {
  const query = new URLSearchParams(search)
  const params: CampaignParams = {}
  const hasCampaign = CAMPAIGN_PARAMS.some((key) => query.has(key))
  for (const key of CAMPAIGN_PARAMS) {
    // Do not mix a new campaign's labels with a previous campaign's persisted fields.
    if (hasCampaign) params[key] = query.get(key)
    else {
      try {
        params[key] = getProperty(key)
      } catch {
        // Analytics must not prevent authentication when persistence is unavailable.
      }
    }
  }
  return params
}
